// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const Card = createStyle({
  variants: {
    size: {
      sm: {
        p: '$3',
        borderRadius: '$sm',
      },
      md: {
        p: '$4',
        borderRadius: '$md',
      },
      lg: {
        p: '$6',
        borderRadius: '$xl',
      },
    },
    variant: {
      elevated: {
        bg: '$bgCard',
        softShadow: '1',
        _dark: {
          bg: '$bgCard',
        },
      },
      outline: {
        bg: '$bgCard',
        borderWidth: 1,
        borderColor: '$borderLight',
        _dark: {
          bg: '$bgCard',
          borderColor: '$borderLight',
        },
      },
      ghost: {
        borderRadius: 'none',
      },
      filled: {
        bg: '$bgSubtle',
        _dark: {
          bg: '$bgSubtle',
        },
      },
      zone: {
        bg: '$bgSubtle',
        px: 0,
        _dark: {
          bg: '$bgSubtle',
        },
      },
    },
  },
  defaultProps: {
    theme: 'light',
    size: 'md',
    variant: 'outline',
  },
});
